import axios from 'axios';

// Configuration globale d'axios pour les utilisateurs
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  withCredentials: true
});

// Configuration axios spécifique pour l'admin
export const adminApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000'
});

// Fonction utilitaire pour vérifier si l'utilisateur est connecté
export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  return !!token;
};

// Fonction utilitaire pour vérifier si l'admin est connecté
export const isAdminAuthenticated = () => {
  const adminToken = localStorage.getItem('adminToken');
  return !!adminToken;
};

// Intercepteur pour ajouter automatiquement le token utilisateur
api.interceptors.request.use(
  (config) => {
    // Récupérer le token depuis localStorage
    const token = localStorage.getItem('authToken');
    
    if (token) {
      // Ajouter le token dans le header Authorization
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour ajouter automatiquement le token admin
adminApi.interceptors.request.use(
  (config) => {
    // Récupérer le token admin depuis localStorage
    const adminToken = localStorage.getItem('adminToken');
    
    if (adminToken) {
      // Ajouter le token admin dans le header Authorization
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs d'authentification utilisateur
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('authToken');
      delete axios.defaults.headers.common['Authorization'];
      
      // Ne pas rediriger automatiquement pour éviter les boucles infinies
      // Laisser chaque composant gérer ses propres erreurs 401
      console.log('🔑 Token utilisateur expiré ou invalide, supprimé du localStorage');
    }
    
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs d'authentification admin
adminApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token admin expiré ou invalide
      localStorage.removeItem('adminToken');
      delete axios.defaults.headers.common['Authorization'];
      
      console.log('🔑 Token admin expiré ou invalide, supprimé du localStorage');
    }
    
    return Promise.reject(error);
  }
);

export default api;
